import React, { Component } from "react";
import { Adsense } from "@ctrl/react-adsense";

import "./player.css";

export class RecomendacionesView extends Component {
  render() {
    return (
      <div
        className="right-separator"
        style={{
          height: "100%",
          paddingLeft: "10px",
        }}
      >
        <div className="recomendation-div">
          <Adsense
            client="ca-pub-8730019109853893"
            slot="9137536101"
            style={{ display: "block" }}
            responsive="true"
            format="auto"
          />
        </div>
      </div>
    );
  }
}

export default RecomendacionesView;
